module.exports = __webpack_public_path__ + "common/icon-close-gray-8343003b21e623f5c101e6133bea5de7.svg";